import styled from "styled-components";

export const ResponsiveContainer = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacings.m} 0;
  display: grid;
  grid-template-columns:
    [full-start] repeat(2, 1fr)
    [content-start] repeat(8, 1fr)
    [content-end] repeat(2, 1fr)
    [full-end];
  grid-template-rows: max-content;
  gap: ${({ theme }) => theme.spacings.xs2};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(12, 1fr);
  }
`;

export const Wrapper = styled.div`
  & + & {
    margin-top: ${({ theme }) => theme.spacings.xs};
  }
`;

export const List = styled.ul`
  margin-left: ${({ theme }) => theme.spacings.xs1};
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xs5};
`;
